import React from 'react';
import classNames from 'classnames';
import { Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import { ThemeProps } from '../../../../shared/prop-types/ReducerProps';
import UserFormModalForm from './UserFormModalForm';

const UserFormModal = ({
  showModal, changeShowModal, theme, setForceRefresh, editData,
}) => {
  const modalClasses = classNames({
    'todo__add-modal': true,
  }, theme.className, 'ltr-support');

  return (
    <Modal
      isOpen={showModal}
      toggle={changeShowModal}
      className={modalClasses}
    >
      <UserFormModalForm
        changeShowModal={changeShowModal}
        setForceRefresh={setForceRefresh}
        editData={editData}
      />
    </Modal>
  );
};

UserFormModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  changeShowModal: PropTypes.func.isRequired,
  theme: ThemeProps.isRequired,
  setForceRefresh: PropTypes.func.isRequired,
  // eslint-disable-next-line
  editData: PropTypes.object,
};

UserFormModal.defaultProps = {
  editData: null,
};

export default UserFormModal;
